let lock = false;
$(document).on("click", ".clone", function(e){
    if(lock) return;
    lock = true;
    var $this = $(this);
    var type = $this.data("action");
    var clone_type = $this.data("clone");
    var func = $this.data("function");
    var name = $this.data("name");
    var cloneable;
    if(typeof $this.data("clone_id") !== 'undefined'){
        cloneable = $(clone_type+"[data-id='"+$this.data("clone_id")+"']");
    }else{
        cloneable = $this.closest(clone_type);
    }
    if(cloneable.length<1){
        cloneable = $(clone_type).last();
    }
    switch(type){
        case "plus":
            var create = $this.data("create");
            if(typeof create !== 'undefined'){
                var data = {};
                if(typeof window.clone_post_data[$this.data("function")] !== 'undefined'){
                    data = window.clone_post_data[$this.data("function")](cloneable);
                }
                
                $.ajax({
                    url:create,
                    method:"POST",
                    data:data,
                    dataType:"json",
                    success: function(response){
                        
                        $(document).trigger("clone", [{"target": clone_type, "data":data, "name":name, "func":func, "response":response, "type":"plus"}]);
                        
                        window.clone_plus(cloneable, name, func, data, response);
                        
                    },
                    error: function(response){
                        lock = false;
                    }
                });
            }else{
                
                $(document).trigger("clone", [{"target": clone_type, "data":data, "name":name, "func":func, "type":"plus"}]);
                
                window.clone_plus(cloneable, clone_type, name, func, data);
                
            }
            break;
        case "minus":
            var remove = $this.data("remove");
            if($(clone_type).length<=1){
                lock = false;
                break;
            }
            if(typeof remove !== 'undefined'){
                var data = {};
                if(typeof window.clone_post_data[$this.data("function")] !== 'undefined'){
                    data = window.clone_post_data[$this.data("function")](cloneable);
                }
                
                $.ajax({
                    url:remove,
                    method:"POST",
                    data:data,
                    dataType:"json",
                    success: function(response){
                        $(document).trigger("clone", [{"target": clone_type, "data":data, "name":name, "func":func, "type":"minus"}]);
                
                        window.clone_minus(cloneable, $this);
                    },
                    error: function(response){
                        lock = false;
                    }
                });
            }else{
                $(document).trigger("clone", [{"target": clone_type, "data":data, "name":name, "func":func, "type":"minus"}]);
                
                window.clone_minus(cloneable, $this, data);
            }
            break;
        default:
            lock = false;
            break;
    }
    
    return false;

});

window.clone_functions = {};
window.clone_post_data = {};

window.clone_plus = function(cloneable, name, func, data, response){
    
    cloneable.find('select.select2').each(function () {
        $(this).select2('destroy');
        $(this).off("select2:select");
        $(this).removeData("select2Id");
        $(this).removeAttr("data-select2-id");
        $(this).data("label", $("label[for='"+$(this).attr("id")+"']"));
        $(this).removeAttr("id");
        $(this).find("option").removeAttr("data-select2-id");
    });

    cloneable.find('.datepicker').each(function(){
        $(this).datepicker().destroy();
    });

    var clone = cloneable.clone();
    clone.insertAfter(cloneable);

    /*Set Unique ID*/
    $.each(clone.find("[id]"), function(){
        var id = $(this).attr("id");
        var new_id = uniqid();
        $(this).attr("id", new_id);
        clone.find("[for='"+id+"']").attr("for", new_id);
    });
    
    var id = uniqid();
    if(typeof response !== 'undefined'){
        id = response.id;
    }
    clone.find('[name*="'+name+'["]').attr('name', function (index, attr) {
        var io = attr.lastIndexOf(name);
        var i = io == -1 ? -1 : io + name.length;
        var parse = attr.substring(i, attr.length);
        return name+parse.replace(/^\[[^\]]+]/, function () {
            return "["+id+"]";
        });
    });

    /*Reinitialize Select2*/
    cloneable.find('.select2').each(function (i, e){
        var id = uniqid();
        var label = $(this).data("label");
        if(typeof label !== 'undefined'){
            label.attr("for", id);
        }
        $(this).attr("id", id);
        $(this).select2();
    });

    clone.find('.select2').each(function (i, e){
        var id = uniqid();
        var label = $(this).data("label");
        if(typeof label !== 'undefined'){
            label.attr("for", id);
        }
        $(this).attr("id", id);
        $(this).find('option:selected').removeAttr("selected");
        $(this).select2();
    });
    
    /*Datepicker*/      
    cloneable.find('.form-datepicker input').each(function(i, e){
        window.init_datepicker($(e));
    });
    
    clone.find('.form-datepicker input').each(function(i, e){
        window.init_datepicker($(e));
    });
    
    clone.find(":input:not(.datepicker):not(.clone-skip)").val("").trigger("change");
    
    clone.attr("data-id", id).data("id", id);
    
    if(typeof func !== 'undefined'){
        if(typeof clone_functions[func] !== 'undefined'){
            clone_functions[func](clone, data);
        }
    }
    
    if(typeof response !== 'undefined'){
        form_populate(clone, response, "[name='"+name+"["+id+"]");
    }
    
    lock = false;
    
};

window.clone_minus = function(cloneable, func, data){
    
    cloneable.remove();
    
    if(typeof clone_functions[func] !== 'undefined'){
        clone_functions[func](null, data);
    }
    
    lock = false;
    
};

$(document).on("change", ".clone-number", function(){

    var $this = $(this);
    var clone_type = $this.data("clone");
    var name = $this.data("name");
    var cloneable = $(clone_type).first();
    var parent = cloneable.parent();
    var len = $(this).val();    
        
    if(len==0){
        parent.hide();
    }else{
        parent.show();
        var clone = cloneable.clone();
        var children = parent.children();
        if(children.length==len) return;
        if(children.length>len){
            children.last().remove();
        }else{
            parent.append(clone);
            clone.find(":input").val("");
            var id = uniqid();
            clone.find('[name*="'+name+'["]').attr('name', function (index, attr) {
                var io = attr.lastIndexOf(name);
                var i = io == -1 ? -1 : io + name.length;
                var parse = attr.substring(i, attr.length);
                return name+parse.replace(/^\[[^\]]+]/, function () {
                    return "["+id+"]";
                });
            });
        }
    }
    
});



// WEBPACK FOOTER //
// ./resources/assets/js/clone.js